// extracted by mini-css-extract-plugin
export default {"chartPrimaryColour":"#2f477c","chartLightBlueColour":"#0a9dec","chartLightGreenColour":"#98e053","chartNegativeRedColour":"#ff5252"};